export enum STREET_SORT_FIELD {
  TRUE_VALUE = 'trueValue',
  KVBO = 'kvbo',
  KVD = 'kvd',
  KTS = 'kts',
  HCS = 'hcs',
}
